export default "__VITE_ASSET__FIHuOnc$__"